module.exports = __webpack_public_path__ + "static/media/7.f4ac11f2.mp3";